module.exports = __webpack_public_path__ + "static/img/r-1-3.0ba1ca8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer3/role-1/r-1-3.png
// module id = hddW
// module chunks = 0